<template>
  <div class="d-flex justify-content-center kid-box">
    <transition
      appear
      v-bind:css="false"
      v-on:before-enter="beforeEnterLanding"
      v-on:enter="enterLanding"
      v-on:leave="leaveLanding"
    >
			<div class="kid">
				<div class="hotspots" v-if="state.showHotspots">
					<transition-group
								appear
								v-bind:css="false"
								v-on:before-enter="beforeEnterHotspot"
								v-on:enter="enterHotspot"
							>
						<hot-spot v-for="(item, index) in hotspots" :class="`hotspot`+item" :key="index" :index="item"></hot-spot>
					</transition-group>
				</div>

        <div ref="tooltip" class="tooltip-box" v-html="$t('home.speech_bubble')"></div>
        <div v-if="!showSpin" class="home-cta-container" @click="setShowSpin(true)">
          <div class="btn-spin"><img src="../../assets/imgs/sm-spin.png"> <span v-html="$t('home.spin_button')"></span></div>
        </div>
			</div>
		</transition>
    <SpinHouse 
        class="home-spin"
        v-if="showSpin" 
        :triggerClose="triggerClose"
        :sprite="spriteSheet"
        @set-showspin="setShowSpin()"
        :anims="houseSpriteAnims"
        :stageSize="stageSize"
      />
      <div class="spin-bg" v-if="showSpin">

        <div class="home-cta-container" @click="setShowSpin(true)">
          <div class="btn-spin"><img src="../../assets/imgs/sm-spin.png"> <span v-html="$t('home.spin_button')"></span></div>
        </div>
      </div>

  </div>
</template>

<script>
import HotSpot from "../particle/HotSpot";
import SpinHouse from "../particle/SpinHouse"
import gsap from 'gsap';
import { inject } from "vue";
import spriteImg from '../../assets/imgs/spins/omghouse-main.png'

export default {
  components: {
    HotSpot,
    SpinHouse
  },
  data () {
		return {
			hotspots: [
				1, 2, 3, 4, 5, 6, 7
			],
      showSpin: false,
      triggerClose: false,
      spriteSheet: spriteImg,
      houseSpriteAnims: {
        idle: [
          // x, y, width, height (4 frames)
          0, 0, 500, 500,
          500, 0, 500, 500,
          1000, 0, 500, 500,
          1500, 0, 500, 500,
          0, 500, 500, 500,
          500, 500, 500, 500,
          1000, 500, 500, 500,
          1500, 500, 500, 500,
          0, 1000, 500, 500,
          // 500, 1000, 500, 500,
          // 1000, 1000, 500, 500,
          // 1500, 1000, 500, 500,
          // 0, 1500, 500, 500,
          // 500, 1500, 500, 500,
          // 1000, 1500, 500, 500,
          // 1500, 1500, 500, 500,
        ],
        reverse: [
          0, 1000, 500, 500,
          1500, 500, 500, 500,
          1000, 500, 500, 500,
          500, 500, 500, 500,
          0, 500, 500, 500,
          1500, 0, 500, 500,
          1000, 0, 500, 500,
          500, 0, 500, 500,
          0, 0, 500, 500,
        ]
      },
      stageSize: {
        width: 500,
        height: 500
      }
		}
	},
  setup() {
    const store = inject("store");
    return {
			actions: store.actions,
			state: store.state
    };
  },
  mounted() {
    this.floatTooltip(this.$refs.tooltip);
  },
  methods: {
    setShowSpin(val) {
      console.log('setShowSpin', val);
      this.triggerClose = !this.triggerClose;
      if(!val || val === undefined) this.triggerClose = false;
      this.showSpin = val;
    },
    // GSAP transitions
    beforeEnterLanding(el) {
      gsap.set(el, { 
        opacity: 0,
        scale: 2
      });
    },
    enterLanding(el, done) {
			console.log(el);
			let that = this;
      gsap.to(el, 0.4, {
				opacity: 1,
        scale: 1,
				onComplete: function(){
          if(that.state.firstVisit) {
            that.actions.toggleIntro(true);
          }
					done();
				}
			}).delay(0.5);
    },
    leaveLanding(el, done) {
      gsap.to(el, 1, { scale: 2, onComplete: done });
    },
    beforeEnterHotspot(el) {
      gsap.set(el, { opacity: 0, scale: 0});
    },
    enterHotspot(el, done) {
      gsap.to(el, 0.7, {
				opacity: 1,
				scale: 1,
				ease:'Bounce.easeOut',
				onComplete: done
			}).delay(0.5);
    },

	}
}
</script>

<style lang="scss">
.kid {
	width: 406px;
	height: 500px;
  background: url("../../assets/imgs/kid.png") no-repeat;
  background-size: contain;
  margin-right: 50px;
  position: relative;
}
.kid-box {
  padding-top: 25vh;
}
@media (max-width: 414px) {
  // .kid-box {
  //   padding-top: 57%;
  // }
  .kid {
    width: 397px;
    height: 500px;
    margin-right: 0px;
    background: url("../../assets/imgs/sm-kid.png") no-repeat;
    background-size: contain;
  }
}
.tooltip-box {
  width: 120px;
  padding: 5px 10px;
  background-color: #fff;
  position: absolute;
  font-family: ProximaSoft;
  font-size: 16px;
  right: 2em;
  top: -3em;
  color: #48c0ba;
  font-weight: bold;
  text-align: center;
  line-height: 18px;

  &:before {
    content: "";
    position: absolute;
    top: 100%;
    width: 0;
    height: 0;
    border-left: 0px solid transparent;
    border-top: 27px solid #fff;
    border-right: 14px solid transparent;
    right: 50px;
  }
}
@media (max-width: 414px) {
  .tooltip-box {
    top: -6em;
  }
}
.spin-bg {
  .home-cta-container {
    top: 75%;
    pointer-events: auto;
  }
}
.home-spin {
width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  
}
</style>
